<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <b-input
          v-model="searchText"
          debounce="500"
          trim
          size="sm"
          placeholder="search..."
        ></b-input>
        <small class="text-muted"
          >If not found, it means that there is no manual settings for the
          level.</small
        >
        <small class="text-muted">It will be using the default values.</small>
      </b-col>
      <b-col cols="3">
        <b-button
          size="sm"
          variant="outline-primary"
          class="d-inline-block ml-3"
          @click="addLevel"
        >
          Add
        </b-button>
      </b-col>
    </b-row>
    <b-list-group>
      <b-list-group-item
        v-for="level in filteredLevels"
        :key="level.levelConfigId"
        @click="loadLevel(level)"
        class="dashboard-list-item"
      >
        <b-row>
          <b-col>
            <span>
              {{ level.levelCaption }}
            </span>
          </b-col>
          <b-col cols="3" sm="2" lg="1">
            <b-badge variant="info" v-if="level.isFilterable"
              >In Filter
            </b-badge>
          </b-col>
          <b-col cols="3" sm="2" lg="1">
            <b-badge variant="secondary" v-if="level.isHidden">Hidden</b-badge>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ level.levelId }}</small>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

    <b-modal
      v-model="formModal"
      centered
      hide-header
      size="lg"
      button-size="sm"
      ok-title="Submit"
      @ok="submit"
    >
      <b-row class="mb-3">
        <b-col>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="deleteLevel"
            class="float-right"
            >Delete
          </b-button>
        </b-col>
      </b-row>
      <b-form ref="main-form">
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Level Unique Name</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.levelId"
              placeholder="[Dim Brand].[Brand].[Brand]"
              size="sm"
              autofocus
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Level Caption</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.levelCaption"
              placeholder="Brand"
              size="sm"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Data Type</div>
            <div>
              <small class="text-muted">
                This will affect how the filter works
              </small>
            </div>
          </b-col>
          <b-col>
            <b-select
              v-model="formItems.dataType"
              size="sm"
              :options="dataTypes"
              required
            ></b-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Show in Columns?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.isHidden"
              :value="false"
              :unchecked-value="true"
            ></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Show in Filters?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.isFilterable"
              :value="true"
              :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import notification from '@/mixins/notification';
import adminServices from '../../services/adminServices';

export default {
  name: 'LevelConfigs',
  props: ['cubeId'],
  mixins: [notification],
  mounted() {
    this.getList();
  },
  computed: {
    filteredLevels() {
      const searchText = this.searchText.toLowerCase();
      let filteredLevels = _.filter(this.levels, { cubeConfigId: this.cubeId });
      filteredLevels = _.filter(filteredLevels, level => {
        return level.levelId.toLowerCase().includes(searchText);
      });
      return filteredLevels;
    },
  },
  data() {
    return {
      levels: [],
      formItems: defaultFormItems(),
      dataTypes: [
        { value: 'AFFILIATECODE', text: 'Affiliate Code' },
        { value: 'BRAND', text: 'Brand' },
        { value: 'DATE1', text: 'Date 1' },
        { value: 'DATE2', text: 'Date 2' },
        { value: 'GENERAL', text: 'General' },
        { value: 'MEMBERCODE', text: 'Member Code' },
        { value: 'MONTH1', text: 'Month 1' },
        { value: 'MONTH2', text: 'Month 2' },
        { value: 'USERNAME', text: 'Username' },
        { value: 'YEAR', text: 'Year' },
      ],

      searchText: '',
      formModal: false,
      isEdit: false,
    };
  },
  methods: {
    getList() {
      adminServices.getLevelConfigs().then(resp => {
        this.levels = resp.data;
      });
    },
    loadLevel(level) {
      this.isEdit = true;
      this.formItems = {
        ..._.cloneDeep(level),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    addLevel() {
      this.isEdit = false;
      this.formItems = {
        ...defaultFormItems(),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    deleteLevel() {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete setting?', { centered: true })
        .then(value => {
          if (value) {
            this.formModal = false;

            adminServices.deleteLevelConfigs(this.formItems.id).then(() => {
              this.PromptSuccess(
                'Success',
                'Setting had been deleted successfully.'
              );
              this.levels = _.filter(
                this.levels,
                level => level.id !== this.formItems.id
              );
            });
          }
        });
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const formItems = _.cloneDeep(this.formItems);
      if (this.isEdit) {
        this.$bvModal
          .msgBoxConfirm('Proceed to edit setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              adminServices.putLevelConfigs(formItems).then(() => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been updated successfully.'
                );
                let levels = _.filter(
                  this.levels,
                  level => level.id !== formItems.id
                );
                levels.push(formItems);
                this.levels = levels;
              });
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm('Proceed to add setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;

              adminServices.postLevelConfigs(formItems)
                .then(resp => {
                  this.PromptSuccess(
                    'Success',
                    'Setting had been added successfully.'
                  );
                  this.levels.push(resp.data);
                });
            }
          });
      }
    },
  },
};

const defaultFormItems = () => {
  return {
    levelId: '',
    levelCaption: '',
    dataType: 'GENERAL',
    isHidden: false,
    isFilterable: true,
    cubeConfigId: 1,
  };
};
</script>

<style scoped>
.dashboard-list-item {
  cursor: pointer;
}

.dashboard-list-item:hover {
  background-color: #ebebeb;
}
</style>